import Intro from './components/Intro';
import Configurator from './components/Configurator';
import Review from './components/Review';
import MobileBar from './components/MobileBar';
import { useBuild } from './hooks/useBuild';

const App = () => {
  const build = useBuild();

  return (
    <main className="pb-20 lg:pb-0">
      <Intro />
      <Configurator build={build} />
      <Review build={build} />
      <MobileBar build={build} />
    </main>
  );
};

export default App;
